export const DIGITAL_LEARNING_1_CONSTANTS = {
  DEFAULT_ROW: {
    id: "1",
    meta_priority: 1,
    meta_status: true,
    meta_description: "description",
    meta_description_text_color: "#222222",
    meta_title: "title line 1",
    meta_title_line_2: "title line 2",
    meta_title_text_color_line_1: "#222222",
    meta_title_text_color_line_2: "#342B7C",
    meta_icon: "",
    meta_alt_icon: "icon",
    enable_animation: false,
  },

  KEY_NUMBERS_FIELDS_CONFIG: [
    {
      fieldName: "desktop_background_color",
      label: "Desktop Background Color",
      value: "#FFFFFF",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "e.g. #FFFFFF",
      required: false,
      defaultValue: "#FFFFFF",
    },
    {
      fieldName: "mobile_background_color",
      label: "Mobile Background Color",
      value: "#FFFFFF",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "e.g. #FFFFFF",
      required: false,
      defaultValue: "#FFFFFF",
    },
    {
      fieldName: "backvariant",
      label: "Background Variant",
      value: "variant_3",
      valueType: "string",
      filedType: "SELECT",
      placeholder: "Select Background Variant",
      required: false,
      defaultValue: "variant_3",
      className: "h-9 py-1.5 text-sm",
      iconClassName: "!size-4",
      options: [
        { label: "Variant 1", value: "variant_1" },
        { label: "Variant 2", value: "variant_2" },
        { label: "Variant 3", value: "variant_3" },
      ],
    },
    {
      fieldName: "gradient_color_1",
      label: "Gradient Color 1",
      value: "#00D4EB",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "e.g. #00D4EB",
      required: false,
      defaultValue: "#00D4EB",
    },
    {
      fieldName: "gradient_color_2",
      label: "Gradient Color 2",
      value: "#000000",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "e.g. #000000",
      required: false,
      defaultValue: "#000000",
    },
    {
      fieldName: "gradient_color_3",
      label: "Gradient Color 3",
      value: "#000000",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "e.g. #000000",
      required: false,
      defaultValue: "#000000",
    },
    {
      fieldName: "gradient_color_4",
      label: "Gradient Color 4",
      value: "#5345C3",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "e.g. #5345C3",
      required: false,
      defaultValue: "#5345C3",
    },
    {
      fieldName: "pre_title",
      label: "Pre Title",
      value: "Digital Learning",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "e.g. Digital Learning,",
      required: false,
      defaultValue: "",
    },
    {
      fieldName: "pre_title_color",
      label: "Pre Title Color",
      value: "#222222CC",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "e.g. #222222",
      required: false,
      defaultValue: "#222222CC",
    },
    {
      fieldName: "title",
      label: "Title",
      value: "Real-World Connections",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "e.g. Real-World Connections",
      required: false,
      defaultValue: "Real-World Connections",
    },
    {
      fieldName: "title_start_color",
      label: "Title Gradient Start Color",
      value: "#342B7C",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "e.g. #342B7C",
      required: false,
      defaultValue: "#342B7C",
    },
    {
      fieldName: "title_end_color",
      label: "Title Gradient End Color",
      value: "#02A7B6",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "e.g. #02A7B6",
      required: false,
      defaultValue: "#02A7B6",
    },
    {
      fieldName: "title_gradient_angle",
      label: "Title Gradient Angle",
      value: "180deg",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "e.g. 180deg",
      required: false,
      defaultValue: "180deg",
    },
    {
      fieldName: "description",
      label: "Description",
      value: "description",
      valueType: "string",
      filedType: "TEXT_AREA",
      placeholder: "Enter description",
      required: false,
      defaultValue: "description",
    },
    {
      fieldName: "description_color",
      label: "Description Color",
      value: "#222222CC",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "e.g. #222222CC",
      required: false,
      defaultValue: "#222222CC",
    },
    {
      fieldName: "image",
      label: "Image",
      value: "image",
      valueType: "string",
      filedType: "FILE",
      placeholder: "Enter image",
      required: false,
      defaultValue: "",
    },
    {
      fieldName: "alt_image",
      label: "Image Alt Text",
      value: "",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "e.g. image ",
      required: false,
      defaultValue: "",
    },
    {
      fieldName: "video",
      label: "Video",
      value: "",
      valueType: "string",
      filedType: "FILE",
      placeholder: "Enter video file",
      required: false,
      defaultValue: "",
    },
    {
      fieldName: "cta_type",
      label: "CTA Click Action",
      value: "lead_drop",
      valueType: "string",
      filedType: "SELECT",
      placeholder: "Select CTA action",
      required: false,
      defaultValue: "lead_drop",
      className: "h-9 py-1.5 text-sm",
      iconClassName: "!size-4",
      options: [
        { label: "Lead Drop (Form popup)", value: "lead_drop" },
        { label: "Link (Navigate to URL)", value: "link" },
      ],
    },
    {
      fieldName: "cta_link",
      label: "CTA Link URL",
      value: "",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "e.g. https://example.com/apply",
      required: false,
      defaultValue: "",
    },
    {
      fieldName: "cta_text",
      label: "CTA Text (Max 50 chars)",
      value: "Apply Now",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "e.g. apply now",
      required: false,
      defaultValue: "Apply Now",
    },
    {
      fieldName: "cta_text_color",
      label: "CTA Text Color",
      value: "#FFFFFF",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "e.g. #FFFFFF",
      required: false,
      defaultValue: "#FFFFFF",
    },
    {
      fieldName: "cta_backcolor_start_color",
      label: "CTA Background Start Color",
      value: "#02A7B6",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "CTA gradient start (optional)",
      required: false,
      defaultValue: "#02A7B6",
    },
    {
      fieldName: "cta_backcolor_end_color",
      label: "CTA Background End Color",
      value: "#342B7C",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "CTA gradient end (optional)",
      required: false,
      defaultValue: "#342B7C",
    },
    {
      fieldName: "cta_gradient_angle",
      label: "CTA Gradient Angle",
      value: "180deg",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "e.g. 180deg",
      required: false,
      defaultValue: "180deg",
    },
    {
      fieldName: "cta_icon",
      label: "CTA Icon",
      value: "",
      valueType: "string",
      filedType: "FILE",
      placeholder: "Enter CTA icon",
      required: false,
      defaultValue: "",
    },
    {
      fieldName: "alt_cta_icon",
      label: "CTA Icon Alt Text",
      value: "",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "e.g. icon",
      required: false,
      defaultValue: "",
    },
    {
      fieldName: "enable_animation",
      label: "Enable Animation",
      value: false,
      valueType: "boolean",
      filedType: "TOGGLE",
      placeholder: "Enable/Disable scroll animation",
      required: false,
      defaultValue: false,
    },
    {
      fieldName: "status",
      label: "Status",
      value: false,
      valueType: "boolean",
      filedType: "TOGGLE",
      placeholder: "Enable/Disable Digital Learning",
      required: false,
      defaultValue: true,
    },
  ],

  METADATA_FIELDS: [
    {
      header: "Title (Line 1)",
      fieldName: "meta_title",
      value: "",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Enter Title Line 1 ",
    },
    {
      header: "Title (Line 2 - Highlighted)",
      fieldName: "meta_title_line_2",
      value: "",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Enter Title Line 2",
    },
    {
      header: "Title Line 1 Color",
      fieldName: "meta_title_text_color_line_1",
      value: "#222222",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Title line 1 color",
      defaultValue: "#222222",
    },
    {
      header: "Title Line 2 Color",
      fieldName: "meta_title_text_color_line_2",
      value: "#342B7C",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Title line 2 color",
      defaultValue: "#342B7C",
    },
    {
      header: "Description",
      fieldName: "meta_description",
      value: "",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Enter Description",
    },
    {
      header: "Description Text Color",
      fieldName: "meta_description_text_color",
      value: "#222222",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Description text color",
      defaultValue: "#222222",
    },
    {
      header: "Priority",
      fieldName: "meta_priority",
      value: 1,
      valueType: "number",
      filedType: "INPUT",
      placeholder: "Enter Priority",
      required: true,
    },
    {
      header: "Status",
      fieldName: "meta_status",
      value: true,
      valueType: "boolean",
      filedType: "TOGGLE",
      placeholder: "Enable/Disable this item",
      defaultValue: true,
    },
    {
      header: "Icon URL",
      fieldName: "meta_icon",
      value: "",
      valueType: "string",
      filedType: "FILE",
      placeholder: "Enter icon URL",
    },
    {
      header: "Icon Alt Text",
      fieldName: "meta_alt_icon",
      value: "",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "e.g. icon1",
    },
  ],
};
